<!-- ── Page header ──────────────────────────────────────────────────────────
     Title, search and every list action on one row. Action order matches the
     other lists — filter, clear, then the page's own actions, primary last
     (WB-7275). This page has no download and no column settings.
     No (searchInput) binding: search runs off the control's valueChanges. -->
<ui-page-header
  [title]="'companies_groups.companies_groups' | translate"
  lucideIcon="List"
  [searchable]="true"
  [searchControl]="searchControl"
  [searchPlaceholder]="'common.search' | translate">

  <!-- Filter, with its clear badge (see ui-filter-action). -->
  <ui-filter-action
    [active]="hasFilters()"
    (filter)="openFilter()"
    (clear)="clearFilters()"
  ></ui-filter-action>

  <!-- Bulk actions for the current selection live in the floating
       ui-bulk-actions-bar at the bottom of the table, not here. -->

  <!-- New group -->
  <ui-button
    *appHasPermission="{ module: 'company', action: 'create' }"
    type="primary"
    icon="plus-cc"
    iconSize="large"
    [label]="('common.new' | translate) + ' ' + ('companies_groups.group' | translate)"
    (click)="addCompaniesGroups()">
  </ui-button>
</ui-page-header>

<!-- ── Table ────────────────────────────────────────────────────────────── -->
<div class="list-companies-groups__table" [class.list-companies-groups__table--with-bulk-bar]="selection.hasSelection">
  <div class="list-companies-groups__table-scroll">
    <div class="list-companies-groups__table-header">
      <div class="list-companies-groups__table-cell list-companies-groups__table-cell--checkbox" (click)="$event.stopPropagation()">
        <ui-checkbox
          *appHasPermission="{ module: 'company', action: 'delete' }"
          [checked]="selection.isAllSelected"
          [indeterminate]="selection.isPartialSelected"
          [ariaLabel]="'common.select_all' | translate"
          (changed)="selection.toggleAll($event.checked)">
        </ui-checkbox>
      </div>
      <div class="list-companies-groups__table-cell">{{ 'companies_groups.groupe_name' | translate }}</div>
      <div class="list-companies-groups__table-cell">{{ 'common.description' | translate }}</div>
      <div class="list-companies-groups__table-cell">{{ 'companies_groups.number_of_companies' | translate }}</div>
      <div class="list-companies-groups__table-cell">{{ 'common.created_date' | translate }}</div>
    </div>

    <ng-container *ngIf="!(isAppLoading$ | async) && (companiesGroups$ | async) as groups">
      <ng-container *ngIf="groups.length > 0">
        <div *ngFor="let group of groups"
          class="list-companies-groups__table-row"
          (click)="onRowClick(group.id)">
          <div class="list-companies-groups__table-cell list-companies-groups__table-cell--checkbox"
            (click)="$event.stopPropagation()">
            <ui-checkbox
              *appHasPermission="{ module: 'company', action: 'delete' }"
              [checked]="selection.isSelected(group.id)"
              [ariaLabel]="'common.select' | translate"
              (changed)="selection.toggleOne(group.id, $event.checked, $event)">
            </ui-checkbox>
          </div>
          <div class="list-companies-groups__table-cell list-companies-groups__table-cell--strong">
            {{ group.name }}
          </div>
          <div class="list-companies-groups__table-cell list-companies-groups__table-cell--description">
            {{ group?.description ?? '--' }}
          </div>
          <div class="list-companies-groups__table-cell">{{ group.nbr_company }}</div>
          <div class="list-companies-groups__table-cell">
            {{ group.create_date | adaptToUserUtcOffset | date: DATE_TIME_FORMAT }}
          </div>
        </div>
      </ng-container>

      <div *ngIf="groups.length === 0" class="list-companies-groups__empty">
        <ng-container *ngIf="(filter?.filters?.length ?? 0) === 0 && !key">
          <img class="list-companies-groups__empty-illustration"
            src="assets/icones/no-companies_groups.svg" alt="">
          <h3>{{ 'companies_groups.no_companies_groups' | translate }}</h3>
        </ng-container>
        <ng-container *ngIf="(filter?.filters?.length ?? 0) > 0 || key">
          <img class="list-companies-groups__empty-illustration"
            src="assets/icones/no-result-search.svg" alt="">
          <h3>{{ 'companies_groups.no_data_search' | translate }}</h3>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the header above it.          -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar *ngIf="selection.hasSelection" [count]="selection.count" (cleared)="selection.clear()">
    <button
      *appHasPermission="{ module: 'company', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ───────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination *ngIf="((companiesGroups$ | async)?.length ?? 0) > 0"
    class="list-companies-groups__pagination"
    [pagination]="pagination$ | async"
    (toPageEvent)="toPage($event)">
  </app-pagination>
</div>
